"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    documentUploads: {
        path: "/files",
    },
    documentUploadDetail: {
        path: "/files/:id",
    },
    documentUploadFile: {
        path: "/view-file/:id",
    },
    geocodeDocument: {
        path: "/geocode-file/:id",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnRVcGxvYWRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9kb2N1bWVudFVwbG9hZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxlQUFlLEVBQUU7UUFDZixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Qsb0JBQW9CLEVBQUU7UUFDcEIsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRCxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsZ0JBQWdCO0tBQ3ZCO0lBQ0QsZUFBZSxFQUFFO1FBQ2YsSUFBSSxFQUFFLG1CQUFtQjtLQUMxQjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgZG9jdW1lbnRVcGxvYWRzOiB7XG4gICAgcGF0aDogXCIvZmlsZXNcIixcbiAgfSxcbiAgZG9jdW1lbnRVcGxvYWREZXRhaWw6IHtcbiAgICBwYXRoOiBcIi9maWxlcy86aWRcIixcbiAgfSxcbiAgZG9jdW1lbnRVcGxvYWRGaWxlOiB7XG4gICAgcGF0aDogXCIvdmlldy1maWxlLzppZFwiLFxuICB9LFxuICBnZW9jb2RlRG9jdW1lbnQ6IHtcbiAgICBwYXRoOiBcIi9nZW9jb2RlLWZpbGUvOmlkXCIsXG4gIH0sXG59KTtcbiJdfQ==